import * as React from 'react';
import { Form } from 'react-bootstrap';
import styled from 'styled-components';
import BasicBox4 from '../packages/BasicBox4';
import { theme } from '_constants/theme';
import PackageList2 from '../packages/PackageList2';
const { colors, fontSizes, spaces } = theme;

const StyledBoxContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 32px;
  gap: 16px;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
const StyledStep4Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 45px;
  @media (max-width: 768px) {
    padding-top: 16px;
  }
`;
const StyleFirstRow = styled.div`
  display: flex;
  flex-direction: row;
  padding-bottom: 16px;
  @media (max-width: 768px) {
    flex-direction: column;
    padding-bottom: 0px;
  }
`;
const StyledItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 52%;
  @media (max-width: 768px) {
    width: 100%;
    padding-bottom: 16px;
  }
`;
const StyledBlueHeader = styled.div`
  display: flex;
  flex-direction: column;
  font-family: Montserrat;
  font-weight: 600;
  font-size: 36px;
  line-height: 44px;
  color: #03589c;
  @media (max-width: 768px) {
    text-align: center;
    font-size: 28px;
  }
`;
const StyledText = styled.div`
  font-family: Montserrat;
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  color: #7b848d;
  @media (max-width: 768px) {
    text-align: center;
    font-size: 14px;
    line-height: 24px;
  }
`;
const StyleText = styled.div`
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  color: ${colors.gray[450]};
  text-align: center;
  padding-top: 24px;
  @media (max-width: 768px) {
    padding-top: 0px;
  }
`;
const StyledSatisfactionGuarantee = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 32px;
  padding-bottom: 16px;
  gap: 16px;
  max-width: 530px;
  margin-left: auto;
  margin-right: auto;
`;
const StyledSatisfactionGuaranteeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1000px;
  min-width: 1000px;
  margin-left: auto;
  margin-right: auto;
  @media (max-width: 768px) {
    max-width: 100%;
    min-width: 100%;
  }
`;
export default function TrademarkStep43({
  onChange,
  validated,
  registerTrademarkList,
}) {
  const handleChange = (e) => {
    const event = { target: { name: 'option', value: e } };
    onChange(event);
  };
  return (
    <StyledStep4Container>
      <StyleFirstRow>
        <StyledItemContainer>
          <StyledBlueHeader>Choose a package</StyledBlueHeader>
          <StyledText>
            All packages include lifetime customer support and our 100%
            satisfaction guarantee
          </StyledText>
        </StyledItemContainer>
        {registerTrademarkList && (
          <StyledBoxContainer>
            <BasicBox4
              selected="BASIC"
              name="Basic"
              price={
                registerTrademarkList.filter(
                  (trademarkProduct) => trademarkProduct.option === 'BASIC'
                )[0].price
              }
              processingTime="14 Day Processing Time"
              onChange={handleChange}
              details={true}
            />
            <BasicBox4
              selected="DELUXE"
              name="Standard"
              main={true}
              price={
                registerTrademarkList.filter(
                  (trademarkProduct) => trademarkProduct.option === 'DELUXE'
                )[0].price
              }
              processingTime="5 Day Processing Time"
              onChange={handleChange}
              details={true}
            />
            <BasicBox4
              selected="PREMIER"
              name="Premier"
              price={
                registerTrademarkList.filter(
                  (trademarkProduct) => trademarkProduct.option === 'PREMIER'
                )[0].price
              }
              processingTime="1 Day Express Processing"
              onChange={handleChange}
              details={true}
            />
          </StyledBoxContainer>
        )}
      </StyleFirstRow>
      {registerTrademarkList && (
        <div className="box-wrapper">
          <PackageList2
            registerTrademarkList={registerTrademarkList}
            isV3={true}
          />
          <StyleText>
            Trademark Monitoring is a subscription service that will auto-renew
            for $199 annually at the expiration of your promotional period if
            not cancelled.
          </StyleText>
        </div>
      )}
      <StyledSatisfactionGuarantee>
        <StyledBlueHeader>Satisfaction Guarantee</StyledBlueHeader>
        <StyledText>
          We want every customer to be satisfied, so we will work with any
          customer who has any questions or concerns about their filings.
        </StyledText>
      </StyledSatisfactionGuarantee>
      <StyledSatisfactionGuaranteeContainer>
        {registerTrademarkList && (
          <StyledBoxContainer>
            <BasicBox4
              selected="BASIC"
              name="Basic"
              price={
                registerTrademarkList.filter(
                  (trademarkProduct) => trademarkProduct.option === 'BASIC'
                )[0].price
              }
              processingTime="14 Day Processing Time"
              onChange={handleChange}
            />
            <BasicBox4
              selected="DELUXE"
              name="Standard"
              main={true}
              price={
                registerTrademarkList.filter(
                  (trademarkProduct) => trademarkProduct.option === 'DELUXE'
                )[0].price
              }
              processingTime="5 Day Processing Time"
              onChange={handleChange}
            />
            <BasicBox4
              selected="PREMIER"
              name="Premier"
              price={
                registerTrademarkList.filter(
                  (trademarkProduct) => trademarkProduct.option === 'PREMIER'
                )[0].price
              }
              processingTime="1 Day Express Processing"
              onChange={handleChange}
            />
          </StyledBoxContainer>
        )}
      </StyledSatisfactionGuaranteeContainer>
      {/* next form hided using css (.reg .packages #TrademarkForm) */}
      <Form id="TrademarkForm" noValidate validated={validated}></Form>
    </StyledStep4Container>
  );
}
